import { Grid } from "@material-ui/core";
import { CustomBox } from "components/Box/CustomBox";
import RegularButton from "components/CustomButtons/Button";
import { animations } from "helpers/animations";
import React, { useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import { OrderCard } from "./orders/OrderCard";
import { green } from "@material-ui/core/colors";
import { height } from "./CustomerView";
import { useDispatch, useSelector } from "react-redux";
import { setCallID, getSchedules, getCustomerProducts } from "redux/actions/customers/customersAction";
import { SET_SUGGESTED_UNITS } from "redux/reducers/units_v2/unitsReducer";
import { useSearch } from "hooks/useSearch";
import { CustomerOrderFormModal } from "./orders/CustomerOrderFormModal";
import { ModalV2 } from "components/Modal/ModalV2";
import { useToggle } from "hooks/useToggle";
const greenC = green[200];

const greenB = green[50];

export const OrdersColumn = () => {
  const { customerServices, customer, amazonConnectCall, account } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const {rules} = useSelector(({login}) => login)
  const { stationsList } = useSelector(({ companies }) => companies)
  const { setSnackbar } = useSearch()
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen, setIsModalOpenValue] = useToggle();

  const handleView = async () => {
    if (account) {
      // Clear any existing suggestions
      dispatch({ type: SET_SUGGESTED_UNITS, payload: {} });
      dispatch(setCallID(amazonConnectCall?.callID));
      await dispatch(getSchedules(account.idStation));
      await dispatch(getCustomerProducts(account.id, {
        stations: stationsList,
        customerIdStation: account.idStation
      }));
      setIsModalOpen();
    }
  };
  return (
    <Grid
      item
      md={12}
      lg={3}
      className={animations.fadeRight}
      style={{
        animationDelay: ".7s",
      }}
    >
      <CustomBox
        title="Pedidos"
        icon={
          <>
            {rules.includes("CUSTOMER-SERVICES") && (
              <RegularButton
                justIcon
                round
                color="info"
                size="sm"
                tooltip="Crear pedido"
                onClick={handleView}
              >
                <AddIcon style={{ margin: 0 }} />
              </RegularButton>
            )}
          </>
        }
        style={{ height, overflowY: "scroll" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {(Array.isArray(customerServices) ? customerServices : []).map((order, i) => (
            <OrderCard
              data={order}
              color={greenC}
              label="Completado"
              borderColor={greenB}
              key={order.id}
              index={i}
            />
          ))}
        </div>
      </CustomBox>
      
      <ModalV2
        open={isModalOpen}
        onClose={() => setIsModalOpenValue(false)}
        title="Generar pedido"
        toRight
      >
        <CustomerOrderFormModal 
          account={account} 
          showAccountSelector={true}
          onClose={() => setIsModalOpenValue(false)} 
        />
      </ModalV2>
    </Grid>
  );
};
